module.exports = "mutation authUserCapture($user:CaptureInput!){capture(user:$user){message status user{email firstName lastName id}}}"